import { Trans, useTranslation } from 'react-i18next';
import { LogoCruyffFoundation, LogoLoreal, LogoPuma, LogoRIJKS, LogoSamsung, LogoVlaamse } from './assets';
import { CheckCircleIcon } from '@app/assets';

export const AuthLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-12">
      {/*
        Explicit grid placement (not source order) so mobile can lead with the
        headline + form, and push the benefit bullets below, while desktop keeps
        the classic headline-and-bullets-left / form-right layout.
      */}
      <div className="grid grid-cols-1 gap-y-8 gap-x-8 md:grid-cols-2 md:grid-rows-2">
        <div className="order-1 flex flex-col gap-4 md:order-1 md:col-start-1 md:row-start-1">
          <h1 className="text-4xl font-bold">
            {t('auth.layout.title', "Dynamic QR codes you can update anytime, even after they're printed.")}
          </h1>
          <p className="text-gray-600">
            {t(
              'auth.layout.subtitle',
              'Change the destination whenever you need to. Start free, no credit card required.'
            )}
          </p>
        </div>
        <div className="order-2 w-full max-w-md md:order-3 md:col-start-2 md:row-start-1 md:row-span-2 md:ml-auto">
          {children}
        </div>
        <div className="order-3 flex flex-col gap-3 md:order-2 md:col-start-1 md:row-start-2">
          <div className="flex items-start gap-2">
            <CheckCircleIcon className="mt-0.5 shrink-0" />{' '}
            <Trans i18nKey="auth.layout.benefit1" defaults="Always editable, update your QR even after it's printed" />
          </div>
          <div className="flex items-start gap-2">
            <CheckCircleIcon className="mt-0.5 shrink-0" />{' '}
            <Trans i18nKey="auth.layout.benefit2" defaults="Track every scan in real time" />
          </div>
          <div className="flex items-start gap-2">
            <CheckCircleIcon className="mt-0.5 shrink-0" />{' '}
            <Trans i18nKey="auth.layout.benefit3" defaults="Free to start" />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-4">
        <div className="text-sm text-gray-400">{t('auth.layout.trustedAt')}</div>
        <div className="flex flex-wrap justify-center items-center gap-10 text-gray-400 opacity-70 [&_svg]:h-5 [&_svg]:w-auto">
          <LogoCruyffFoundation />
          <LogoLoreal />
          <LogoPuma />
          <LogoVlaamse />
          <LogoSamsung />
          <LogoRIJKS />
        </div>
      </div>
    </div>
  );
};
